import {Duration} from 'luxon';

import {MetricNumericalRenderer} from '../analyticsFormatHelpers';

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_TEN_MINUTES = 10 * SECONDS_IN_MINUTE;
const SECONDS_IN_HOUR = 60 * SECONDS_IN_MINUTE;
const SECONDS_IN_DAY = 24 * SECONDS_IN_HOUR;

export const renderDurationValue: MetricNumericalRenderer = ({value}) => {
  const isNegative = value < 0; // Luxon doesn't support correctly the formatting of negative durations https://github.com/moment/luxon/issues/415.

  const numberOfSeconds = Math.abs(value);

  if (numberOfSeconds === 0) {
    return '-';
  }

  const duration = Duration.fromObject({seconds: numberOfSeconds});

  let formattedDuration;

  if (numberOfSeconds < SECONDS_IN_MINUTE) {
    formattedDuration = duration.toFormat("s's'");
  } else if (numberOfSeconds < SECONDS_IN_TEN_MINUTES) {
    formattedDuration = duration.toFormat("m'm' s's'");
  } else if (numberOfSeconds < SECONDS_IN_HOUR) {
    formattedDuration = duration.toFormat("m'm'");
  } else if (numberOfSeconds < SECONDS_IN_DAY) {
    formattedDuration = duration.toFormat("h'h' mm'm'");
  } else {
    formattedDuration = duration.toFormat("d'd' hh'h'");
  }

  if (isNegative) {
    return `-${formattedDuration}`;
  }

  return formattedDuration;
};
